import { Alert, Snackbar } from "@mui/material";
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import { createStyles, makeStyles, Theme, StylesProvider } from "@material-ui/core/styles";
import { config } from "../config/config";
import { Warning } from "@mui/icons-material";

interface Props {
  open: any
  onClose: any
  msg: string
}

export const MsgWarnSnackbar = ({ open, onClose, msg }: Props) => {

  const useSnackbarClassStyles = makeStyles((theme: Theme) =>
    createStyles({
      warn: {
        color: "#fff",
        backgroundColor: "#ed6c02"
      }
    })
  );
  const snackbarClass = useSnackbarClassStyles();

  return (
    <StylesProvider>
      <Snackbar
        className={snackbarClass.warn}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} 
        open={open}
        autoHideDuration={config.snackbarDispTime}
        onClose={onClose}
        >
        <Alert
          className={snackbarClass.warn}
          severity="warning"
          sx={{ width: '100%', backgroundColor: '#ed6c02', color: '#fff' }} 
          onClose={onClose}
          iconMapping={{
            error: <ErrorOutline fontSize="inherit" className={snackbarClass.warn} />,
          }}
          >
          {msg}
        </Alert>
      </Snackbar>
    </StylesProvider>
  );
}

export default MsgWarnSnackbar;
